function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "12"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#008AF5",
  d: "M9.337 0H2.663a.898.898 0 00-.898.898v.867H.898A.898.898 0 000 2.663v8.439c0 .496.402.898.898.898h6.674a.899.899 0 00.899-.898v-.867h.866a.898.898 0 00.898-.898V.898A.898.898 0 009.337 0zM7.765 11.102a.193.193 0 01-.193.192H.898a.192.192 0 01-.192-.192v-8.44c0-.105.086-.191.192-.191h6.674c.106 0 .193.086.193.192v8.439zm1.764-1.765a.192.192 0 01-.192.192h-.866V2.663a.899.899 0 00-.899-.898H2.471V.898c0-.106.086-.192.192-.192h6.674c.106 0 .192.086.192.192v8.44z"
})));